import wizButton from './index.vue'

wizButton.install = (Vue) => {
  Vue.component(wizButton.name, wizButton)
}

export default wizButton
